/**
 * Разбор `VITE_SURVEY_REDIRECT_URI_ALLOWLIST` и проверка origin цели редиректа.
 * Звёздочка допускается только как префикс поддомена: `https://*.example.com`.
 *
 * @module utils/surveyRedirectAllowlist
 */

export { isRedirectOriginAllowed } from './surveyRedirectAllowlistCore';

/**
 * Возвращает список непустых шаблонов из переменной окружения (через запятую).
 *
 * @returns {string[]}
 */
export function parseSurveyRedirectAllowlistRaw(): string[] {
  const raw = import.meta.env.VITE_SURVEY_REDIRECT_URI_ALLOWLIST;
  if (typeof raw !== 'string' || raw.trim() === '') {
    return [];
  }
  return raw
    .split(',')
    .map((s) => s.trim())
    .filter((s) => s !== '');
}
